import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

/* Index Views (GET) */
import HomeComponent from './home';
import PostsComponent from './posts';
import ProjectsComponent from './posts';

/* Components */
import { PostDetailComponent } from './posts/post-detail/post-detail.component';
import { ProjectDetailComponent } from './projects/project-detail/project-detail.component';

const routes: Routes = [
  { path: '', redirectTo: '/home', pathMatch: 'full' },
  { path: 'home', component: HomeComponent },
  { path: 'posts', component: PostsComponent },
  { path: 'post/:id', component: PostDetailComponent },
  { path: 'projects', component: ProjectsComponent },
  { path: 'project/:id', component: ProjectDetailComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {useHash: true})],
  exports: [RouterModule]
})
export class AppRoutingModule {}



// WEBPACK FOOTER //
// C:/Users/phildp/ahs/gdm/code/madebygdm/src/app/app-routing.module.ts